<template>
  <div>
    {{ currentTime }}
  </div>
</template>
<script>
export default {
  name: 'ServerClock',
  props: {
    format: {
      type: String,
      default: 'h:mm A zz'
    }
  },
  data: function () {
    return {
      currentTime: ''
    }
  },
  mounted () {
    this.updateClock()
    setInterval(() => this.updateClock(), 1000)
  },
  methods: {
    updateClock () {
      try {
        const currentMoment = this.$ftAPI().clubMomentTz()
        this.currentTime = currentMoment.format(this.format)
      } catch (e) {
        console.warn('Invalid time format', this.format)
      }
    }
  }
}
</script>
